import { createAction } from 'redux-actions';

export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

const addError = createAction(ADD_ERROR);
const removeError = createAction(REMOVE_ERROR);

export default {
    addError,
    removeError
};



// WEBPACK FOOTER //
// ./containers/app/errors/errors-actions.js